import type { JSX } from 'react';
import { Footer } from '@/components/layout';
import styles from './AboutPage.module.css';

const AboutPage = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <h1 className={styles.heading}>About Us</h1>
        <div className={styles.content}>
          <p className={styles.sectionHeading}>What is Slayd?</p>
          <p>
            {`Slayd is your AI-powered fashion discovery companion. We bridge the
            gap between inspiration and purchase — helping you turn any reel,
            post, or fashion moodboard into shoppable outfits in seconds.`}
          </p>
          <p>
            {`Whether you're obsessing over a celeb fit, scrolling Pinterest, or
            sharing a fashion reel with your bestie — just send it to Slayd.
            We'll instantly find similar pieces from 5000+ Indian and global
            fashion brands.`}
          </p>

          <p className={styles.sectionHeading}>Who We Are</p>
          <p>
            {`Slayd is an AI-powered fashion search and discovery platform built
            to help users find fashion products that match their vibe. We enable
            multiple discovery journeys:`}
          </p>
          <ul>
            <li>
              <span className={styles.subHeading}>
                Visual Search from Reels & Posts:
              </span>{' '}
              Share an Instagram reel or post, and we’ll find exact or similar
              outfits using AI-powered image analysis.
            </li>
            <li>
              <span className={styles.subHeading}>
                Natural Language Search:
              </span>{' '}
              Ask for “brunch dresses under 2k” or “Monica Geller-inspired
              outfits” — our AI interprets your intent and finds what fits.
            </li>
            <li>
              <span className={styles.subHeading}>Homepage Discovery:</span>{' '}
              Browse personalized feeds curated by AI based on your fashion
              preferences, saved looks, and past interactions.
            </li>
            <li>
              <span className={styles.subHeading}>
                Curated Moodboards & Collections:
              </span>{' '}
              Discover trending aesthetics and seasonal edits — curated by our
              AI stylist and human team — aligned with your style.
            </li>
          </ul>

          <p className={styles.sectionHeading}>Our Vision</p>
          <p>
            We’re building the universal fashion wishlist for the internet — a
            one-stop platform where your saved styles, moodboards, and inspo
            posts translate into personalized fashion picks, curated feeds, and
            instant shopping.
          </p>
          <p>
            Our goal? To make fashion discovery intuitive, hyper-personalized,
            and just one DM away.
          </p>

          <p className={styles.sectionHeading}>Features</p>

          <ul>
            <li>
              <span className={styles.subHeading}>Reel to Product:</span> DM us
              any Instagram Reel and get links to the exact or similar outfits
              featured — from 5000+ stores like Myntra, Ajio, Newme, Urbanic,
              and more.
            </li>
            <li>
              <span className={styles.subHeading}>Post to Product:</span> Found
              a fire Pinterest or IG post? Share it with Slayd, and we’ll match
              it with the closest available products instantly.
            </li>
            <li>
              <span className={styles.subHeading}>Curation to Closet:</span>{' '}
              Love our curated trend Reels (like “Butter Yellow for Summer”)?
              Send us the post, and we’ll drop all the shoppable links for every
              featured look.
            </li>
            <li>
              <span className={styles.subHeading}>Personalized Discovery:</span>{' '}
              The more you share, the better we understand your style. Your
              taste powers your homepage — with curated boards, mood-based
              edits, and your personal Top 100 picks every week.
            </li>
          </ul>
          <hr />
          <br />
          <p className={styles.subHeading}>
            We connect you with over 250 fashion brands and retailers across
            India and globally, organizing over 10 lakh+ products into smart,
            searchable formats.
          </p>
          <br />
          <p>
            <b>Operated by:</b>
            <br />
            Slayd Technologies Private Limited
            <br />
            74-Pushpanjali Vatika, Avas Vikas Colony, Sadar, Agra, 282007, Uttar
            Pradesh
            <br />
            <b>Email:</b>
            <a href="mailto:hello@slayd.in">hello@slayd.in</a>
            <br />
            <b>Phone:</b> <a href="tel:+917302202036">+91 7302202036</a>
          </p>
        </div>
      </div>
      <div className={styles.footer}>
        <Footer />
      </div>
    </div>
  );
};

export default AboutPage;
